module.exports = __webpack_public_path__ + "static/media/opisanie.387437e0.pdf";